"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Phone, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const BUSINESS_PHONE_TEL = "tel:+15712496482";
const BUSINESS_PHONE_DISPLAY = "+1 (571) 249-6482";
export default function GalleryIntro() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="gallery-intro" className="bg-background text-foreground py-14 md:py-20 lg:py-24">
      <div className="container max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div ref={ref} className={cn("max-w-3xl transition-all duration-300", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 motion-reduce:opacity-100 motion-reduce:translate-y-0")}>
          <div className="border-l-4 border-primary pl-3 mb-4">
            <span className="font-mono text-xs uppercase tracking-widest text-primary font-medium">
              Ablaze Contracting Service LLC
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-normal leading-[1.1] tracking-tight mb-4 text-foreground">
            Our work
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
            Remodelling, flooring, carpentry, tiling, plumbing, power washing, and repairs completed across Dumfries, Virginia and the surrounding area.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Button asChild className="h-11 px-6 rounded font-mono text-xs uppercase tracking-wider">
              <Link to="/BookAppointmentPage" className="inline-flex items-center justify-center gap-2">
                <SafeHydrate><Calendar className="size-4" /></SafeHydrate>
                <span>Book a visit</span>
              </Link>
            </Button>
            <Button variant="outline" asChild className="h-11 px-6 rounded font-mono text-xs uppercase tracking-wider border-border text-foreground hover:border-primary/50">
              <a href="tel:+15712496482" className="inline-flex items-center justify-center gap-2">
                <Phone className="size-4 text-primary" />
                <span>Call {BUSINESS_PHONE_DISPLAY}</span>
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}